import React, {Component} from "react";
import * as Yup from "yup";
import {connect} from "react-redux";
import _ from "lodash";

import AddressForm from "./AddressForm/AddressForm.component";
import {ActionCreator} from "../../../../../actions/actions";
import {HallsActionCreators} from "../../../actions/actionCreators";
import {hallsStoreSelectors} from "../../../store/store";
import {MapCoordinates} from "../../../reducers/mapCoordinates.reducer";

import {homeStoreSelectors} from "../../../../home/store/store";
import {User} from "../../../../auth/reducers/users.reducer";

import {Subsidiary} from "../../../types/subsidiaries";
import {HallCreateBaseInfo} from "../../../../../types/types";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";

import "./CreateHall.component.scss";
import {CreationModes} from "../../../reducers/creationMode.reducer";
import {HallBaseConfig} from "../../../reducers/hallsList.reducer";
import {checkPermission} from "../../../../../utils/Authorization/authorization";
import SearchDynamicHall from "./SearchDynamicHall.component";
import {SubsidiaryUtils} from "../../../../../utils/Subsidiary/SubsidiaryUtils";

const timezomesItems = timezones =>
    timezones.map(obj => ({
        label: obj.timezone,
        value: obj.id
    }));

export interface CreateHallProps {
    updateCreatingHall: ActionCreator;
    mapCoordinates: MapCoordinates;
    subsidiaries: Subsidiary[];
    creatingHall: {
        values: HallCreateBaseInfo;
        isValid: boolean;
    };
    createHall: ActionCreator;
    creationMode: any;
    inspectingHall: HallBaseConfig;
    updateHall: ActionCreator;
    submittingHallLoading: boolean;
    timezonesLoading: boolean;
    timezones: any[];
    getTimezones: ActionCreator;
    userInfo: User;
    getDynamicHall: ActionCreator;
    dynamicHallsLoading: boolean;
    dynamicHalls: any[];
    clearCreateHall: ActionCreator;
    getDynamicHallInfo: ActionCreator;
    dynamicHallInfoLoading: boolean;
    dynamicHallInfo: any[];
    clearDynamicHallInfo: ActionCreator;
}

export interface CreateHallState {
    selectedHalls: any[];
    hallItems: any[];
    dynamicHalls: any[];
    filteredHalls: any[];
    searchHallsLoading: boolean;
    clearSearchTerm: boolean;
    hallInfo: any[];
}

const hallsSearchHeader = (isLoading, onSearch, disabled, clearSearchTerm) => {
    return (
        <SearchDynamicHall
            key={"search-field"}
            onSearch={onSearch}
            isLoading={isLoading}
            clearSearchTerm={clearSearchTerm}
        />
    );
};

class CreateHall extends Component<CreateHallProps, CreateHallState> {
    private timezoneSelect;

    hallFilter: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);
        this.hallFilter = React.createRef();

        this.state = {
            selectedHalls: [],
            hallItems: [],
            dynamicHalls: [],
            filteredHalls: [],
            searchHallsLoading: false,
            clearSearchTerm: false,
            hallInfo: []
        }

        if (this.props.creationMode == CreationModes.EDIT_HALL) {
            this.props.getDynamicHall(this.props.inspectingHall.subsidiary.id);
        }

        this.timezoneSelect = React.createRef();

        this.props.updateCreatingHall(
            {
                ...(this.props.creatingHall
                    ? this.props.creatingHall.values
                    : null),
                allow_license_renew:
                    this.props.creatingHall &&
                    this.props.creatingHall.values.hasOwnProperty(
                        "allow_license_renew"
                    )
                        ? typeof this.props.creatingHall.values
                            .allow_license_renew == "boolean"
                            ? this.props.creatingHall.values.allow_license_renew
                            : Boolean(
                                this.props.creatingHall.values.allow_license_renew
                            )
                        : true
            },
            this.validateForm({
                ...(this.props.creatingHall
                    ? this.props.creatingHall.values
                    : null)
            })
        );

    }

    componentDidMount() {
        if (this.props.creationMode == CreationModes.EDIT_HALL) {
            let name = `${this.props.inspectingHall.name} ¦ ${this.props.inspectingHall.hall_code}`
            if (this.props.inspectingHall.dynamics_status) {
                name += ` ¦ ${this.props.inspectingHall.dynamics_status}`
            }
            this.hallFilter.current.setDisplayString(
                this.props.inspectingHall.hall_code
                    ? name
                    : this.props.inspectingHall.name)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.dynamicHalls, this.state.dynamicHalls)) {
            let _hallItems = []
            nextProps.dynamicHalls.map(hall => {
                _hallItems.push({
                    label: `${hall.Site_Name} ¦ ${hall.Site_Loc_Code} ¦ ${hall.StatusF} `,
                    value: hall.Site_Loc_Code
                })
            })
            this.setState({
                hallItems: _hallItems,
                filteredHalls: _hallItems,
                dynamicHalls: nextProps.dynamicHalls
            });
        }

        if (!_.isEqual(nextProps.dynamicHallInfo, this.state.hallInfo) && nextProps.dynamicHallInfo.length > 0) {
            let values = {
                ...(this.props.creatingHall
                    ? this.props.creatingHall.values
                    : null),
                address_line_1: nextProps.dynamicHallInfo[0]['Address'],
                address_line_2: nextProps.dynamicHallInfo[0]['Address_2']
            };

            this.props.updateCreatingHall(values, this.validateForm(values));
            this.setState({
                hallInfo: [...nextProps.dynamicHallInfo]
            });
        }
    }

    componentWillUnmount() {
        this.props.clearCreateHall();
        this.props.clearDynamicHallInfo();
    }

    validateForm = values => {
        let isValid
        let nameSchema = Yup.string()
            .required("Field is required.")
            .max(20, "Max. 20 characters.")
            .matches(new RegExp(/^[\w\-\ \.]+$/), `Special characters not supported.`)
            .matches(
                new RegExp(/^(?!\.)([\w\-\ \.]?)+$/),
                `Should not start with a '.'`
            );

        if ((values.hall_code && values.hall_code !== 0) || (this.props.creationMode == CreationModes.EDIT_HALL && this.props.inspectingHall.hall_code)) {
            nameSchema = Yup.string()
                .required("Field is required.")
            isValid = values.name &&
                nameSchema.isValidSync(values.name)
        } else {
            isValid = values.name &&
                nameSchema.isValidSync(values.name) &&
                values.address_line_1 &&
                values.address_line_1.length <= 200
        }
        if (values.allow_license_renew && checkPermission('toggle_halls_renew')) {
            if (values.allow_license_automatic_renew) {
                let renewalDaysSchema = Yup.number().min(1, "Must be >= than 1");
                isValid = isValid &&
                    renewalDaysSchema.isValidSync(parseInt(values.renewal_trigger_days))
            }
        }
        if (this.props.creationMode === CreationModes.ADD_HALL)
            return (
                isValid &&
                values.subsidiary &&
                values.timezone
            );
        else if (this.props.creationMode === CreationModes.EDIT_HALL)
            return (isValid);
        else return false;
    };

    onCreate = () => {
        let dataToSend = {...this.props.creatingHall.values}
        if (dataToSend.hall_code === 0) {
            delete dataToSend.hall_code;
        }
        if (dataToSend.allow_license_automatic_renew && dataToSend.renewal_trigger_days)
            dataToSend.renewal_trigger_days = parseInt(dataToSend.renewal_trigger_days)

        if (!dataToSend.allow_license_renew || !dataToSend.allow_license_automatic_renew) {
            dataToSend.allow_license_automatic_renew = false
            dataToSend.renewal_trigger_days = 0
        }
        this.props.createHall(dataToSend);
    };

    onEdit = () => {
        let values = this.props.creatingHall.values
        if (values.hall_code === 0) {
            delete values.hall_code;
        } else if (!values.hall_code && this.props.inspectingHall.hall_code) {
            values.hall_code = this.props.inspectingHall.hall_code
        }
        if (values.subsidiary) delete values.subsidiary
        if (values.timezone) delete values.timezone

        if (values.allow_license_automatic_renew && values.renewal_trigger_days)
            values.renewal_trigger_days = parseInt(values.renewal_trigger_days)

        if (!values.allow_license_renew || !values.allow_license_automatic_renew) {
            values.allow_license_automatic_renew = false
            values.renewal_trigger_days = 0
        }

        this.props.updateHall(
            this.props.inspectingHall.id,
            this.props.inspectingHall.name,
            values
        );

    };

    onSubsidiaryChange = subsidiary => {
        const newFormValues = {
            ...(this.props.creatingHall
                ? this.props.creatingHall.values
                : null),
            subsidiary,
            timezone: null,
            address_line_1: "",
            address_line_2: "",
            name: "",
            hall_code: ""
        };

        this.timezoneSelect.current.selectItem([]);
        this.timezoneSelect.current.setDisplayString("Choose a Timezone...");

        this.hallFilter.current.selectItem([]);
        this.hallFilter.current.setDisplayString("Hall Name");

        const country = this.props.subsidiaries.find(
            obj => obj.id == subsidiary
        ).country.id;
        this.props.getTimezones(country);
        this.props.getDynamicHall(subsidiary);

        this.props.updateCreatingHall(
            newFormValues,
            this.validateForm(newFormValues)
        );

        this.setState({
            clearSearchTerm: true
        });
    };

    switchRenew = value => {
        const newFormValues = {
            ...(this.props.creatingHall
                ? this.props.creatingHall.values
                : null),
            allow_license_renew: !value
        };

        this.props.updateCreatingHall(
            newFormValues,
            this.validateForm(newFormValues)
        );
    };

    switchAutomaticRenew = value => {
        const newFormValues = {
            ...(this.props.creatingHall
                ? this.props.creatingHall.values
                : null),
            allow_license_automatic_renew: !value
        };

        this.props.updateCreatingHall(
            newFormValues,
            this.validateForm(newFormValues)
        );
    };

    changeRenewalDays = value => {
        const newFormValues = {
            ...(this.props.creatingHall
                ? this.props.creatingHall.values
                : null),
            renewal_trigger_days: value.target.value != "" ? value.target.value : null
        };
        this.props.updateCreatingHall(
            newFormValues,
            this.validateForm(newFormValues)
        );
    };

    onTimezoneChange = timezone => {
        const newFormValues = {
            ...(this.props.creatingHall
                ? this.props.creatingHall.values
                : null),
            timezone
        };

        this.props.updateCreatingHall(
            newFormValues,
            this.validateForm(newFormValues)
        );
    };

    onHallSearch = search => {
        let res = this.state.hallItems.filter(item => item.label.toLowerCase().includes(search.toLowerCase()));

        if (search) {
            res.unshift({
                label: (<div className='color-back'><span className='color-text'>[New]</span> {search}
                </div>),
                value: 0
            })
        }

        this.setState({filteredHalls: res, clearSearchTerm: false});
    };

    selectDynamicHall(hall_code) {
        return this.props.dynamicHalls.filter(hall => hall.Site_Loc_Code == hall_code);
    }

    selectHall = e => {
        const hall_code = e;

        const res = this.state.filteredHalls.filter(item => item.value === hall_code);
        let values = {
            ...(this.props.creatingHall
                ? this.props.creatingHall.values
                : null),
            hall_code: hall_code
        };

        if (hall_code === 0) {
            values['name'] = res.length == 1 ? res[0].label.props.children[2] : "";
            if (this.props.creatingHall.values.hall_code && this.props.creatingHall.values.hall_code !== 0) {
                values['address_line_1'] = "";
                values['address_line_2'] = "";
            }
        } else {
            let dynamic_hall = this.selectDynamicHall(hall_code);
            values['name'] = res.length == 1 ? res[0].label : "";
            if (dynamic_hall.length == 1) {
                this.props.getDynamicHallInfo(dynamic_hall[0]['Site_GR_Code']);
            }
        }

        this.props.updateCreatingHall(values, this.validateForm(values));
        this.setState({clearSearchTerm: true})
    };

    render() {
        let hallValue = this.props.creatingHall ? this.props.creatingHall.values.name : ""
        if (this.props.creationMode == CreationModes.EDIT_HALL && this.props.inspectingHall && this.props.inspectingHall.hall_code !== '') {
            this.state.filteredHalls.map(hall => {
                if (hall.label === this.props.creatingHall.values.name) hallValue = hall.value
            })
        }

        return (
            <div id="create-hall">
                <div className="create-content">
                    <div className="new-hall-card">

                        {this.props.creationMode == CreationModes.ADD_HALL && (
                            <React.Fragment>
                                <div className="row">

                                    <div id="subsidiary" className="col-6">
                                        <div className="label-tooltip">
                                            <label className="label">
                                                Subsidiary
                                            </label>
                                        </div>
                                        <Components.SelectMenu
                                            noValueLabel="Choose a subsidiary..."
                                            items={SubsidiaryUtils.subsidiarySelectItems(this.props.subsidiaries)}
                                            value={
                                                this.props.creatingHall
                                                    ? this.props.creatingHall
                                                        .values.subsidiary
                                                    : null
                                            }
                                            onChange={this.onSubsidiaryChange}
                                        />
                                    </div>

                                    <div id="timezome" className="col-6">
                                        <div className="label-tooltip">
                                            <label className="label">
                                                Timezone
                                            </label>
                                        </div>
                                        <Components.SelectMenu
                                            noValueLabel="Choose a Timezone..."
                                            items={timezomesItems(
                                                this.props.timezones
                                            )}
                                            ref={this.timezoneSelect}
                                            disabled={
                                                this.props.creatingHall ==
                                                null ||
                                                this.props.creatingHall.values
                                                    .subsidiary == null ||
                                                this.props.timezones.length == 0
                                            }
                                            value={
                                                this.props.creatingHall
                                                    ? this.props.creatingHall
                                                        .values.timezone
                                                    : null
                                            }
                                            onChange={this.onTimezoneChange}
                                        />
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                        <div className="row">
                            <div className="col-12">
                                <div>
                                    <div className="label-tooltip">
                                        <label className="label">Hall Name</label>
                                    </div>
                                    <div>
                                        <Components.SelectMenu
                                            ref={this.hallFilter}
                                            items={this.state.filteredHalls}
                                            noValueLabel="Hall Name"
                                            headerContainer={hallsSearchHeader(
                                                this.props.dynamicHallsLoading,
                                                this.onHallSearch,
                                                this.props.creatingHall == null || this.props.creatingHall.values.subsidiary == null,
                                                this.state.clearSearchTerm
                                            )}
                                            value={hallValue}
                                            onChange={this.selectHall}
                                            disabled={
                                                this.props.creatingHall == null || (this.props.creationMode == CreationModes.ADD_HALL && this.props.creatingHall.values.subsidiary == null)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br/>

                        {this.props.dynamicHallInfoLoading && (
                            <div className="loading" key="loading">
                                <Components.LoadingRipple
                                    width={100}
                                    height={100}
                                />
                            </div>
                        )}
                        {!this.props.dynamicHallInfoLoading && (
                            <AddressForm validateForm={this.validateForm}/>
                        )}

                        {this.props.creationMode == CreationModes.EDIT_HALL && (
                            <div className="rename-warning">
                                <i className="icon-exclamation-circle-light"></i>
                                Editing a Hall will also generate a new
                                configuration. <b>Download</b> and <b>Upload</b>{" "}
                                it to the server in order to update info.
                            </div>
                        )}

                        {(this.props.userInfo.is_superuser || checkPermission('toggle_halls_renew')) && (
                            <div className="row">
                                <div id="allow_license_renew" className="col-6">
                                    <div className="label-tooltip">
                                        <label className="label">
                                            Allow License Renew
                                        </label>
                                    </div>
                                    <Components.Switch
                                        onClick={this.switchRenew}
                                        on={
                                            this.props.creatingHall
                                                ? this.props.creatingHall.values
                                                    .allow_license_renew
                                                : true
                                        }
                                        enabled={true}
                                    />
                                </div>
                                {this.props.creatingHall && this.props.creatingHall.values.allow_license_renew && (
                                    <div className="col-6 renewal_trigger_days">

                                        <div className="label-tooltip">
                                            <label className="label">
                                                Enable Automatic License Renew
                                            </label>
                                        </div>
                                        <Components.Switch
                                            onClick={this.switchAutomaticRenew}
                                            on={
                                                this.props.creatingHall
                                                    ? this.props.creatingHall.values
                                                        .allow_license_automatic_renew
                                                    : true
                                            }
                                            enabled={true}
                                        />
                                        {this.props.creatingHall.values.allow_license_automatic_renew && (
                                            <React.Fragment>
                                                <br /><br />
                                                <div className="label-tooltip">
                                                    <label className="label">
                                                        Renewal Days / Days Before Expiration
                                                    </label>
                                                </div>
                                                <input
                                                    className={`input ${!(this.props.creatingHall.values.renewal_trigger_days > 0) && "input-error"
                                                    }`}
                                                    type="number"
                                                    placeholder="Duration (days)"
                                                    onChange={this.changeRenewalDays}
                                                    defaultValue={
                                                        this.props.creatingHall.values.renewal_trigger_days
                                                            ? this.props.creatingHall.values.renewal_trigger_days.toString()
                                                            : ""
                                                    }
                                                />
                                                {
                                                    !(this.props.creatingHall.values.renewal_trigger_days > 0) &&
                                                    <div className="input-error">
                                                        <span className="input-error-message">
                                                            {'Must be > than 0'}
                                                        </span>
                                                    </div>
                                                }
                                            </React.Fragment>
                                        )}

                                    </div>
                                )}
                            </div>
                        )}

                        {this.props.creationMode == CreationModes.ADD_HALL && (
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        className={`red-btn create-btn ${
                                            this.props.submittingHallLoading
                                                ? "loading"
                                                : ""
                                        }`}
                                        disabled={
                                            !this.props.creatingHall ||
                                            !this.props.creatingHall.isValid ||
                                            this.props.submittingHallLoading
                                        }
                                        onClick={this.onCreate}
                                    >
                                        Create
                                    </button>
                                </div>
                            </div>
                        )}

                        {this.props.creationMode == CreationModes.EDIT_HALL && (
                            <div className="row">
                                <div className="col-12">
                                    <button
                                        className={`red-btn create-btn ${
                                            this.props.submittingHallLoading
                                                ? "loading"
                                                : ""
                                        }`}
                                        disabled={
                                            !this.props.creatingHall ||
                                            !this.props.creatingHall.isValid ||
                                            this.props.submittingHallLoading
                                        }
                                        onClick={this.onEdit}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    mapCoordinates: hallsStoreSelectors.mapCoordinates(state),
    subsidiaries: hallsStoreSelectors.subsidiaryList(state),
    creatingHall: hallsStoreSelectors.creatingHall(state),
    creationMode: hallsStoreSelectors.creationMode(state),
    inspectingHall: hallsStoreSelectors.inspectingHall(state),
    submittingHallLoading: hallsStoreSelectors.submittingHallLoading(state),
    timezones: hallsStoreSelectors.timezones(state),
    timezonesLoading: hallsStoreSelectors.timezonesLoading(state),
    userInfo: homeStoreSelectors.userInfo(),
    dynamicHalls: hallsStoreSelectors.dynamicHalls(state),
    dynamicHallsLoading: hallsStoreSelectors.dynamicHallsLoading(state),
    dynamicHallInfo: hallsStoreSelectors.dynamicHallInfo(state),
    dynamicHallInfoLoading: hallsStoreSelectors.dynamicHallInfoLoading(state),
});

const mapDispatchToProps = {
    updateCreatingHall: HallsActionCreators.updateCreatingHall,
    createHall: HallsActionCreators.createHall,
    updateHall: HallsActionCreators.updateHall,
    getTimezones: HallsActionCreators.getTimezones,
    getDynamicHall: HallsActionCreators.getDynamicHall,
    getDynamicHallInfo: HallsActionCreators.getDynamicHallInfo,
    clearCreateHall: HallsActionCreators.clearCreateHall,
    clearDynamicHallInfo: HallsActionCreators.clearDynamicHallInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateHall);
